import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/solfilm-foretag")({
  component: () => <Outlet />,
});
